export const PAYMENT_TRANSFER = {
  NO_INTENTION: 'No intention',
  MAKE_PAYMENTS: 'Make Payments',
  RECEIVE_PAYMENTS: 'Receive Payments',
  MAKE_AND_RECEIVE_PAYMENTS: 'Make and receive payments'
};
let prev = '';
export const removeFormValues = values => {
  if (prev && prev !== values.accountDetailsPayment) {
    switch (values.accountDetailsPayment) {
      case PAYMENT_TRANSFER.NO_INTENTION:
      case PAYMENT_TRANSFER.MAKE_PAYMENTS:
      case PAYMENT_TRANSFER.RECEIVE_PAYMENTS:
      case PAYMENT_TRANSFER.MAKE_AND_RECEIVE_PAYMENTS:
        resetPayments(values);
        break;
      default:
        break;
    }
  }
  prev = values.accountDetailsPayment;
};

export const isValidPaymentCondition = (values, condition) =>
  values && values.accountDetailsPayment === condition;

export const resetPreviousPaymentTransfer = value => {
  prev = value;
};
const resetPayments = values => {
  values.send_payments = [];
  values.receive_payments = [];
};

export const generateSum = formValues =>
  formValues
    ? formValues.map(value => parseInt(Object.values(value)[0])).reduce((prev, curr) => prev + curr)
    : 0;
